import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { Datagrid } from 'components';
import { Worker } from 'app/types/worker';

const Logs = ({ worker }: { worker: Worker }) => {
  const { t } = useTranslation();

  return (
    <Card title={t('common.log')}>
      <Datagrid
        data={worker}
        keys={[
          'ModifiedAt',
          'ModifiedBy',
          'CreatedAt',
          'CreatedBy',
        ]}
        translationsNamespace="common"
      />
    </Card>
  );
};

export default Logs;
